module.exports = __webpack_public_path__ + "res/Roboto-Medium-webfont.eot?a47037be2fd985780095442e4ea9d4e3";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Medium-webfont.eot
// module id = 76
// module chunks = 0